function initFireplaceConfigurator() {
  var app = document.getElementById('fp-configurator');
  if (!app) return;

  // ── Pricing constants ─────────────────────────────────────────────────────
  var BASE_PRICE      = 7350;
  var BASE_DIAMETER   = 32;
  var BASE_HEIGHT     = 76;
  var PRICE_PER_DIAM  = 400;
  var PRICE_PER_INCH  = 25;
  var SCREEN_PRICE    = 150;
  var PARTITION_PRICE = 1400;
  var DIAMETER_STEPS  = [32, 36, 40, 44, 48];

  // ── State ─────────────────────────────────────────────────────────────────
  var config = {
    model: null, diameter: null, fuel: null,
    height: null, pitch: null, pitchDeg: null,
    screen: null, partition: null
  };

  var fuelLabels = {
    'wood':            'Wood Burning',
    'electric-heater': 'Electric Heater',
    'electric-vapor':  'Electric Water Vapor',
    'bio-ethanol':     'Bio-Ethanol'
  };

  var pitchLabels = {
    'flat':     'Flat / Level (0 degrees)',
    'slight':   'Slight (1-18 degrees)',
    'moderate': 'Moderate (19-34 degrees)',
    'steep':    'Steep (35-45 degrees)',
    'custom':   'Custom / To Be Confirmed'
  };

  // ── Fuel info content ─────────────────────────────────────────────────────
  var fuelInfo = {
    'wood': {
      title: 'Wood Burning',
      tag:   'Traditional · Real Flame',
      body:  '<p>Our wood burning fireplaces are compatible with <strong style="color:#f0c98a;">Dura-Vent</strong> chimney products, the industry standard for venting systems. All chimney piping will need to be purchased separately based on your installation requirements.</p>' +
             '<div class="fp-modal-note">Chimney piping is not included with the unit and must be sourced separately. We recommend consulting a certified installer to determine the correct Dura-Vent configuration for your space.</div>' +
             '<p>Watch our full video installation guide to understand the setup process before purchase:</p>' +
             '<p><a href="https://youtu.be/Enf9-PpmMM8" target="_blank" rel="noopener">&#9654; Watch Video Install Guide &rarr;</a></p>'
    },
    'electric-heater': {
      title: 'Electric Heater',
      tag:   'Heat Producing · No Venting Required',
      body:  '<p>The electric heater insert produces real warmth and requires a dedicated electrical circuit run to the ceiling location where the fireplace will be mounted.</p>' +
             '<div class="fp-modal-note"><strong style="color:#f0c98a;">Electrical Requirements:</strong><br>1,500 watts &nbsp;·&nbsp; 12/2 wire &nbsp;·&nbsp; 20 amp dedicated breaker<br>The circuit must be connected at the ceiling mounting point by a licensed electrician.</div>' +
             '<p>No gas lines or venting are required. This is our most straightforward installation for homeowners who want real heat without a chimney.</p>'
    },
    'electric-vapor': {
      title: 'Electric Water Vapor',
      tag:   'Decorative · No Heat · No Venting',
      body:  '<p>The water vapor fireplace insert creates a stunning, ultra-realistic flame effect using purified water and LED lighting. It produces no actual heat and requires no venting.</p>' +
             '<div class="fp-modal-note"><strong style="color:#f0c98a;">Important:</strong> This model produces <em>no heat</em>. It is a purely decorative flame effect.</div>' +
             '<div class="fp-modal-note"><strong style="color:#f0c98a;">Installation Requirements:</strong><br>12/2 wire connected at the ceiling mounting point<br>&#189;" water supply line connected at the ceiling<br><strong>Purified water only</strong> — tap water will damage the unit and void the warranty.</div>' +
             '<p>See what a water vapor fireplace looks like in action:</p>' +
             '<div style="margin-top:1.2rem;display:flex;justify-content:center;">' +
             '<video controls playsinline style="width:auto;max-width:320px;max-height:560px;aspect-ratio:9/16;border-radius:8px;display:block;background:#000;">' +
             '<source src="https://cdn.shopify.com/videos/c/o/v/e5edda7ed7b4407693c1da32ba2cf4da.mp4" type="video/mp4">' +
             'Your browser does not support the video tag.' +
             '</video></div>'
    },
    'bio-ethanol': {
      title: 'Bio-Ethanol',
      tag:   'Clean Burning · No Venting Required',
      body:  '<p>Bio-ethanol fireplaces burn clean, denatured alcohol fuel and produce a real, open flame without the need for a chimney, flue, or gas line.</p>' +
             '<div class="fp-modal-note">Adequate room ventilation is recommended. Bio-ethanol fuel is purchased separately and is widely available online and in home improvement stores.</div>' +
             '<p>No electrical connection is required. This is the simplest installation option available.</p>'
    }
  };

  // ── Helpers ───────────────────────────────────────────────────────────────
  function getEl(id) { return document.getElementById(id); }

  function makeClickable(el) {
    if (!el) return;
    el.style.pointerEvents = 'auto';
    el.style.cursor = 'pointer';
    el.style.position = 'relative';
    el.style.zIndex = '1';
  }

  function applyClickable() {
    var els = app.querySelectorAll('.fp-chip, .fp-fuel-card, .fp-pitch-card, .fp-model-card');
    for (var i = 0; i < els.length; i++) makeClickable(els[i]);
    var btns = app.querySelectorAll('button');
    for (var j = 0; j < btns.length; j++) makeClickable(btns[j]);
  }
  applyClickable();

  // ── Event delegation (capture phase) ─────────────────────────────────────
  app.addEventListener('click', function(e) {
    var el = e.target;

    // Check for info button first
    var infoBtn = el;
    while (infoBtn && infoBtn !== app) {
      if (infoBtn.classList && infoBtn.classList.contains('fp-info-btn')) {
        e.stopPropagation();
        e.preventDefault();
        openFuelModal(infoBtn.getAttribute('data-fuel'));
        return;
      }
      infoBtn = infoBtn.parentNode;
    }

    // Option cards
    var card = e.target;
    while (card && card !== app) {
      if (card.classList) {
        if (card.classList.contains('fp-chip') ||
            card.classList.contains('fp-fuel-card') ||
            card.classList.contains('fp-pitch-card') ||
            card.classList.contains('fp-model-card')) {
          handleOptionClick(card);
          return;
        }
        if (card.tagName === 'BUTTON') {
          handleButtonClick(card);
          return;
        }
      }
      card = card.parentNode;
    }
  }, true);

  // ── Modal ─────────────────────────────────────────────────────────────────
  var overlay = getEl('fp-modal-overlay');
  var closeBtn = getEl('fp-modal-close');

  if (closeBtn) {
    closeBtn.addEventListener('click', function(e) {
      e.stopPropagation();
      closeModal();
    }, true);
  }
  if (overlay) {
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    }, true);
  }

  function openFuelModal(fuelKey) {
    var info = fuelInfo[fuelKey];
    if (!info || !overlay) return;
    var content = getEl('fp-modal-content');
    if (content) {
      content.innerHTML =
        '<h3>' + info.title + '</h3>' +
        '<span class="fp-modal-tag">' + info.tag + '</span>' +
        info.body;
    }
    overlay.classList.add('open');
    overlay.style.display = 'flex';
  }

  function closeModal() {
    if (!overlay) return;
    overlay.classList.remove('open');
    overlay.style.display = 'none';
    var video = overlay.querySelector('video');
    if (video) video.pause();
  }

  // ── Option click handler ──────────────────────────────────────────────────
  function handleOptionClick(el) {
    var group = el.getAttribute('data-group');
    var value = el.getAttribute('data-value');
    var label = el.getAttribute('data-label') || value;
    if (!group || !value) return;

    var siblings = app.querySelectorAll('[data-group="' + group + '"]');
    for (var i = 0; i < siblings.length; i++) siblings[i].classList.remove('active');
    el.classList.add('active');
    config[group] = value;

    if (group === 'model')    { updateSummaryField('fp-s-model', label); checkPartitionVisibility(); }
    if (group === 'diameter') { updateSummaryField('fp-s-diameter', value + ' inches'); checkPartitionVisibility(); }
    if (group === 'fuel')     { updateSummaryField('fp-s-fuel', label); }
    if (group === 'screen')   { updateSummaryField('fp-s-screen', value === 'yes' ? 'Yes (+$150)' : 'No'); }
    if (group === 'partition'){ updateSummaryField('fp-s-partition', value === 'yes' ? 'Yes (+$1,400)' : 'No'); }
    if (group === 'pitch') {
      config.pitchDeg = null;
      var degInput = getEl('fp-pitch-degrees');
      if (degInput) degInput.value = '';
      updateSummaryField('fp-s-pitch', label);
    }
    updatePrice();
  }

  function handleButtonClick(btn) {
    if (btn.hasAttribute('disabled')) return;
    if (btn.id === 'fp-cta-btn')  openCustomerModal();
    if (btn.id === 'fp-spec-btn') downloadSpec();
  }

  // ── Glass partition visibility ────────────────────────────────────────────
  function checkPartitionVisibility() {
    var section    = getEl('fp-glass-partition-section');
    var summaryRow = getEl('fp-s-partition-row');
    var show = (config.model === 'float' && config.diameter === '48');
    if (section)    section.style.display    = show ? 'block' : 'none';
    if (summaryRow) summaryRow.style.display  = show ? 'flex'  : 'none';
    if (!show) {
      config.partition = null;
      var partChips = app.querySelectorAll('[data-group="partition"]');
      for (var i = 0; i < partChips.length; i++) partChips[i].classList.remove('active');
      setEmpty('fp-s-partition', 'Not selected');
    }
    updatePrice();
  }

  // ── Height input ──────────────────────────────────────────────────────────
  var heightInput = getEl('fp-height-input');
  if (heightInput) {
    heightInput.addEventListener('input', function() {
      var val = parseFloat(this.value);
      if (this.value && val > 0) {
        config.height = val;
        updateSummaryField('fp-s-height', val + ' inches');
      } else {
        config.height = null;
        setEmpty('fp-s-height', 'Not entered');
      }
      updatePrice();
    }, true);
  }

  // ── Pitch degree input ────────────────────────────────────────────────────
  var pitchDegInput = getEl('fp-pitch-degrees');
  if (pitchDegInput) {
    pitchDegInput.addEventListener('input', function() {
      var deg = parseFloat(this.value);
      if (this.value === '' || isNaN(deg)) { config.pitchDeg = null; return; }
      config.pitchDeg = deg;
      config.pitch = deg === 0 ? 'flat' : deg <= 18 ? 'slight' : deg <= 34 ? 'moderate' : deg <= 45 ? 'steep' : 'custom';
      updateSummaryField('fp-s-pitch', deg + ' degrees');
      updatePrice();
    }, true);
  }

  function updateSummaryField(id, val) {
    var el = getEl(id);
    if (!el) return;
    el.textContent = val;
    el.classList.remove('empty');
  }
  function setEmpty(id, msg) {
    var el = getEl(id);
    if (!el) return;
    el.textContent = msg;
    el.classList.add('empty');
  }

  // ── Pricing ───────────────────────────────────────────────────────────────
  function calcPrice() {
    var diam   = config.diameter ? parseInt(config.diameter) : null;
    var height = config.height;
    if (!diam || !height) return null;

    var diamIdx      = DIAMETER_STEPS.indexOf(diam);
    var baseIdx      = DIAMETER_STEPS.indexOf(BASE_DIAMETER);
    var diamAdd      = (diamIdx - baseIdx) * PRICE_PER_DIAM;
    var heightAdd    = Math.max(0, height - BASE_HEIGHT) * PRICE_PER_INCH;
    var screenAdd    = config.screen === 'yes' ? SCREEN_PRICE : 0;
    var partitionAdd = config.partition === 'yes' ? PARTITION_PRICE : 0;

    return {
      base:         BASE_PRICE,
      diamAdd:      diamAdd,
      heightAdd:    heightAdd,
      screenAdd:    screenAdd,
      partitionAdd: partitionAdd,
      total:        BASE_PRICE + diamAdd + heightAdd + screenAdd + partitionAdd
    };
  }

  function updatePrice() {
    var result    = calcPrice();
    var priceEl   = getEl('fp-price-display');
    var ctaBtn    = getEl('fp-cta-btn');
    var specBtn   = getEl('fp-spec-btn');
    var breakdown = getEl('fp-breakdown');

    if (!result) {
      priceEl.textContent = 'Select diameter & height';
      priceEl.className = 'fp-price-amount incomplete';
      ctaBtn.setAttribute('disabled', 'disabled');
      specBtn.setAttribute('disabled', 'disabled');
      if (breakdown) breakdown.style.display = 'none';
      return;
    }

    priceEl.textContent = '$' + result.total.toLocaleString('en-US');
    priceEl.className = 'fp-price-amount';
    ctaBtn.removeAttribute('disabled');
    specBtn.removeAttribute('disabled');

    if (breakdown) {
      breakdown.style.display = 'block';

      var bdDiam = getEl('fp-bd-diameter');
      if (result.diamAdd > 0 && bdDiam) {
        bdDiam.style.display = 'flex';
        getEl('fp-bd-diameter-label').textContent = 'Diameter upgrade (' + config.diameter + ' inches)';
        getEl('fp-bd-diameter-val').textContent = '+$' + result.diamAdd.toLocaleString('en-US');
      } else if (bdDiam) { bdDiam.style.display = 'none'; }

      var bdHeight = getEl('fp-bd-height');
      if (result.heightAdd > 0 && bdHeight) {
        bdHeight.style.display = 'flex';
        var extraIn = config.height - BASE_HEIGHT;
        getEl('fp-bd-height-label').textContent = 'Height (' + config.height + ' in / +' + extraIn + ' in over base)';
        getEl('fp-bd-height-val').textContent = '+$' + result.heightAdd.toLocaleString('en-US');
      } else if (bdHeight) { bdHeight.style.display = 'none'; }

      var bdScreen = getEl('fp-bd-screen');
      if (bdScreen) bdScreen.style.display = result.screenAdd > 0 ? 'flex' : 'none';

      var bdPart = getEl('fp-bd-partition');
      if (bdPart) bdPart.style.display = result.partitionAdd > 0 ? 'flex' : 'none';
    }
  }

  // ── Customer info modal ───────────────────────────────────────────────────
  function openCustomerModal() {
    var result = calcPrice();
    if (!result) return;
    var content = getEl('fp-modal-content');
    if (!overlay || !content) return;
var inputStyle = 'width:100%;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.12);border-radius:4px;padding:10px 12px;font-size:14px;color:#e8e4dc;outline:none;box-sizing:border-box;';
var labelStyle = 'display:block;font-size:11px;letter-spacing:.1em;text-transform:uppercase;color:#6a6660;margin-bottom:6px;margin-top:12px;';

content.innerHTML =
  '<h3>Your Details</h3>' +
  '<span class="fp-modal-tag">Complete your order — we\'ll send you an invoice</span>' +
  '<div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;">' +
    '<div><label style="' + labelStyle + '">First Name</label><input id="fp-c-first" type="text" placeholder="Jane" style="' + inputStyle + '"></div>' +
    '<div><label style="' + labelStyle + '">Last Name</label><input id="fp-c-last" type="text" placeholder="Smith" style="' + inputStyle + '"></div>' +
  '</div>' +
  '<label style="' + labelStyle + '">Email Address</label>' +
   '<input id="fp-c-email" type="email" placeholder="jane@example.com" style="' + inputStyle + '">' +

      '<div class="fp-modal-note" style="margin-top:16px;">Your estimated total is <strong style="color:#f0c98a;">$' + result.total.toLocaleString('en-US') + '</strong>. We\'ll send a secure invoice to your email — no payment is taken now.</div>' +
      '<button id="fp-submit-order-btn" type="button" style="width:100%;margin-top:16px;background:#b46a1e;border:none;border-radius:4px;padding:15px;font-size:12px;font-weight:500;letter-spacing:.16em;text-transform:uppercase;color:#f5f0e8;cursor:pointer;pointer-events:auto;">Submit Order &amp; Receive Invoice</button>' +
      '<p id="fp-submit-error" style="display:none;color:#e87070;font-size:13px;margin-top:10px;text-align:center;"></p>';

    overlay.classList.add('open');
    overlay.style.display = 'flex';

    setTimeout(function() {
      var submitBtn = getEl('fp-submit-order-btn');
      if (submitBtn) {
        submitBtn.addEventListener('click', function(e) {
          e.stopPropagation();
          submitOrder(result);
        }, true);
      }
    }, 50);
  }

  // ── Submit via Formspree ──────────────────────────────────────────────────
  function submitOrder(result) {
    var first = (getEl('fp-c-first')  || {}).value || '';
    var last  = (getEl('fp-c-last')   || {}).value || '';
    var email = (getEl('fp-c-email')  || {}).value || '';
    var phone = (getEl('fp-c-phone')  || {}).value || '';
    var addr1 = (getEl('fp-c-addr1')  || {}).value || '';
    var addr2 = (getEl('fp-c-addr2')  || {}).value || '';
    var city  = (getEl('fp-c-city')   || {}).value || '';
    var state = (getEl('fp-c-state')  || {}).value || '';
    var zip   = (getEl('fp-c-zip')    || {}).value || '';

    var errEl = getEl('fp-submit-error');
    if (!first || !last || !email) {
      if (errEl) { errEl.textContent = 'Please fill in all required fields.'; errEl.style.display = 'block'; }
      return;
    }
    if (email.indexOf('@') < 0) {
      if (errEl) { errEl.textContent = 'Please enter a valid email address.'; errEl.style.display = 'block'; }
      return;
    }
    if (errEl) errEl.style.display = 'none';

    var submitBtn = getEl('fp-submit-order-btn');
    if (submitBtn) { submitBtn.textContent = 'Submitting...'; submitBtn.setAttribute('disabled', 'disabled'); }

    var pitchStr = config.pitchDeg !== null ? config.pitchDeg + ' degrees' : (config.pitch || 'Not specified');
    var showPartition = config.model === 'float' && config.diameter === '48';

    var breakdownStr = 'Base unit (32in / 76in / Wood): $7,350';
    if (result.diamAdd > 0) breakdownStr += ' | Diameter upgrade (' + config.diameter + 'in): +$' + result.diamAdd.toLocaleString('en-US');
    if (result.heightAdd > 0) breakdownStr += ' | Height surcharge (+' + (config.height - 76) + 'in @ $25/in): +$' + result.heightAdd.toLocaleString('en-US');
    if (result.screenAdd > 0) breakdownStr += ' | Metal screen: +$150';
    if (result.partitionAdd > 0) breakdownStr += ' | Glass partition: +$1,400';

    var formData = new FormData();
    formData.append('_subject', 'New Fireplace Order — ' + first + ' ' + last + ' — $' + result.total.toLocaleString('en-US'));
    formData.append('Customer Name',        first + ' ' + last);
    formData.append('Email',                email);
    formData.append('Model',                config.model ? config.model.charAt(0).toUpperCase() + config.model.slice(1) : 'Not specified');
    formData.append('Diameter',             (config.diameter || '') + ' inches');
    formData.append('Fuel Source',          fuelLabels[config.fuel] || config.fuel || 'Not specified');
    formData.append('Height',               (config.height || '') + ' inches');
    formData.append('Ceiling Angle',        pitchStr);
    formData.append('Metal Screen',         config.screen === 'yes' ? 'Yes' : 'No');
    if (showPartition) formData.append('Glass Partition', config.partition === 'yes' ? 'Yes' : 'No');
    formData.append('Price Breakdown',      breakdownStr);
    formData.append('TOTAL PRICE',          '$' + result.total.toLocaleString('en-US'));

    fetch('https://formspree.io/f/mnjojdyq', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (data.ok) {
        var content = getEl('fp-modal-content');
        if (content) {
          content.innerHTML =
            '<div style="text-align:center;padding:1rem 0;">' +
            '<div style="font-size:48px;margin-bottom:1rem;">&#10003;</div>' +
            '<h3 style="margin-bottom:.5rem;">Order Received!</h3>' +
            '<span class="fp-modal-tag">We\'ll be in touch shortly</span>' +
            '<p style="margin-top:1rem;">Thank you, <strong style="color:#f0c98a;">' + first + '</strong>! ' +
            'Your order for <strong style="color:#f0c98a;">$' + result.total.toLocaleString('en-US') + '</strong> has been received.</p>' +
            '<p style="margin-top:.75rem;color:#8a8680;">Our team will send a Shopify invoice to ' +
            '<strong style="color:#f0c98a;">' + email + '</strong> within 1 business day.</p>' +
            '</div>';
        }
      } else {
        if (submitBtn) { submitBtn.textContent = 'Submit Order & Receive Invoice'; submitBtn.removeAttribute('disabled'); }
        if (errEl) { errEl.textContent = 'Something went wrong. Please try again.'; errEl.style.display = 'block'; }
      }
    })
    .catch(function() {
      if (submitBtn) { submitBtn.textContent = 'Submit Order & Receive Invoice'; submitBtn.removeAttribute('disabled'); }
      if (errEl) { errEl.textContent = 'Could not submit. Please email us at conor@thewoodwardhome.com.'; errEl.style.display = 'block'; }
    });
  }

  // ── Spec sheet ────────────────────────────────────────────────────────────
  function downloadSpec() {
    var result = calcPrice();
    if (!result) return;

    var now = new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    var pitchStr = config.pitchDeg !== null ? config.pitchDeg + ' degrees' : (config.pitch || 'Not specified');
    var showPartition = config.model === 'float' && config.diameter === '48';

    var breakdownRows = '<tr><td>Base unit (32" diameter, 76" height, wood burning)</td><td>$7,350</td></tr>';
    if (result.diamAdd > 0) breakdownRows += '<tr><td>Diameter upgrade (' + config.diameter + '")</td><td>+$' + result.diamAdd.toLocaleString('en-US') + '</td></tr>';
    if (result.heightAdd > 0) {
      var extraIn = config.height - BASE_HEIGHT;
      breakdownRows += '<tr><td>Height surcharge (+' + extraIn + '" @ $25/in)</td><td>+$' + result.heightAdd.toLocaleString('en-US') + '</td></tr>';
    }
    if (result.screenAdd > 0) breakdownRows += '<tr><td>Metal screen</td><td>+$150</td></tr>';
    if (result.partitionAdd > 0) breakdownRows += '<tr><td>Glass partition</td><td>+$1,400</td></tr>';

    var partitionRow = showPartition ? '<tr><td>Glass Partition</td><td>' + (config.partition === 'yes' ? 'Yes' : 'No') + '</td></tr>' : '';

    var html =
      '<!DOCTYPE html><html><head><meta charset="UTF-8"><title>Fireplace Spec Sheet</title>' +
      '<style>body{font-family:Georgia,serif;max-width:700px;margin:40px auto;color:#1a1a18;padding:0 24px}' +
      '.hdr{display:flex;justify-content:space-between;align-items:flex-end;border-bottom:3px solid #1a1a18;padding-bottom:16px;margin-bottom:28px}' +
      '.brand{font-size:22px;font-weight:bold}.dt{font-size:12px;color:#7a7870;text-transform:uppercase;margin-top:4px}' +
      'h2{font-size:28px;font-weight:400;margin-bottom:4px}.sub{color:#7a7870;font-size:14px;margin-bottom:2rem}' +
      '.sec{font-size:10px;letter-spacing:.14em;text-transform:uppercase;color:#b46a1e;margin:2rem 0 .6rem;border-bottom:1px solid #e8e4dc;padding-bottom:6px}' +
      'table{width:100%;border-collapse:collapse;margin-bottom:1rem}' +
      'td{padding:10px 12px;border-bottom:1px solid #f0ece6;font-size:14px}' +
      'td:first-child{color:#7a7870;width:45%}td:last-child{font-weight:500}' +
      '.bd td{font-size:13px;color:#5a5854}.bd td:last-child{color:#3a3834;font-weight:400}' +
      '.total-row td{font-weight:600;font-size:15px;border-top:2px solid #e8e4dc;color:#1a1a18;padding-top:14px}' +
      '.ft{font-size:11px;color:#9a9890;border-top:1px solid #e8e4dc;padding-top:12px;margin-top:2rem;line-height:1.6}' +
      '</style></head><body>' +
      '<div class="hdr"><div><div class="brand">Woodward Home</div><div class="dt">Custom Fireplace Specification</div></div><div style="font-size:12px;color:#9a9890">thewoodwardhome.com</div></div>' +
      '<h2>Custom Fireplace Order</h2>' +
      '<div class="sub">Built-to-order specification sheet &mdash; generated ' + now + '</div>' +
      '<div class="sec">Configuration</div><table>' +
      '<tr><td>Model</td><td>' + (config.model ? config.model.charAt(0).toUpperCase() + config.model.slice(1) : 'Not specified') + '</td></tr>' +
      '<tr><td>Diameter</td><td>' + config.diameter + ' inches</td></tr>' +
      partitionRow +
      '<tr><td>Fuel Source</td><td>' + (fuelLabels[config.fuel] || 'Not specified') + '</td></tr>' +
      '<tr><td>Height</td><td>' + config.height + ' inches</td></tr>' +
      '<tr><td>Ceiling Pitch</td><td>' + pitchStr + '</td></tr>' +
      '<tr><td>Metal Screen</td><td>' + (config.screen === 'yes' ? 'Yes' : 'No') + '</td></tr>' +
      '</table>' +
      '<div class="sec">Pricing</div>' +
      '<table class="bd">' + breakdownRows +
      '<tr class="total-row"><td>Estimated Total</td><td>$' + result.total.toLocaleString('en-US') + '</td></tr>' +
      '</table>' +
      '<div class="ft">This spec sheet is for reference only. Final pricing confirmed at order. Contact us at thewoodwardhome.com/pages/contact with any questions.</div>' +
      '</body></html>';

    var blob = new Blob([html], { type: 'text/html' });
    var url  = URL.createObjectURL(blob);
    var a    = document.createElement('a');
    a.href = url;
    a.download = 'Woodward_Fireplace_Spec.html';
    document.body.appendChild(a);
    a.click();
    setTimeout(function() { document.body.removeChild(a); URL.revokeObjectURL(url); }, 100);
    showToast('Spec sheet downloaded!');
  }

  // ── Toast ─────────────────────────────────────────────────────────────────
  function showToast(msg) {
    var t = getEl('fp-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(function() { t.classList.remove('show'); }, 3000);
  }
}

if (document.readyState === 'complete') {
  initFireplaceConfigurator();
} else {
  window.addEventListener('load', initFireplaceConfigurator);
}